export default {
    //查询全部工作类型
    vendorList: "/v2/es/vendor/search",
    // 查询vendorType
    vendorType: "/v2/es/vendor/searchMaintenance",
    // vendor检索
    vendorSearch: "/v2/es/vendor/search",
    // MonthlyWorker 获取Vendor
    getMaintenanceVendor: "/v2/es/vendor/searchMaintenance",
};
